export default class OptOut {
  constructor( node ) {
    this.node = node;
    this.radioOn = node.querySelector( '#opt-in--on' );
    this.radioOff = node.querySelector( '#opt-in--off' );
    this.initEtracker();
    this.handleRadioButton();
  }
  initEtracker() {
    let cookie = this.getCookie( 'et_oi_v2' );
    if ( cookie === 'yes' ) {
      this.radioOn.checked = true;
      this.setEtracker();
    } else {
      this.radioOff.checked = true;
      this.deleteAllCookies();
    }
  }
  setEtracker() {
    if ( _etracker.isOptInDialogExpected()) {
      _etracker.enableTracking();
    }
  }
  handleRadioButton() {
    this.radioOn.addEventListener( 'change', () => {
      if ( this.radioOn.checked === true ) {
        _etracker.enableTracking();
      }
    });

    this.radioOff.addEventListener( 'change', () => {
      if ( this.radioOff.checked === true ) {
        _etracker.disableTracking();
        this.deleteAllCookies();
      }
    });
  }
  getCookie( cname ) {
    let name = cname + '=';
    let decodedCookie = decodeURIComponent( document.cookie );
    let ca = decodedCookie.split( ';' );
    for ( let i = 0; i < ca.length; i++ ) {
      let c = ca[ i ];
      while ( c.charAt( 0 ) == ' ' ) {
        c = c.substring( 1 );
      }
      if ( c.indexOf( name ) == 0 ) {
        return c.substring( name.length, c.length );
      }
    }
    return '';
  }
  deleteAllCookies() {
    let cookies = document.cookie.split( ';' );

    for ( let i = 0; i < cookies.length; i++ ) {
      let cookie = cookies[ i ];
      let eqPos = cookie.indexOf( '=' );
      let name = eqPos > -1 ? cookie.substr( 0, eqPos ) : cookie;
      if ( name.includes( 'et_oi_v2' ) || name.includes( 'cookie-agreed' )) {
        // do nothing
      } else {
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;Path=/';
      }
    }
  }
}
